export enum UserRoles {
    LanterUser = 'LanterUser',
    CustomerUser = 'CustomerUser',
    DealerUser = 'DealerUser',
}
